__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['axp-travel-home-search'].baseUrl;
import TopLevelComponent from './components/HomeSearch';
export default TopLevelComponent;
;
if (!global.BROWSER) {
  TopLevelComponent.appConfig = Object.assign({}, TopLevelComponent.appConfig, {
    appCompatibility: "5.x || 6.x"
  });
}
;
if (!global.BROWSER) {
  TopLevelComponent.appConfig = Object.assign({}, TopLevelComponent.appConfig, {
    requiredExternals: {
      '@americanexpress/conditional-features': '^3.0.0',
      '@americanexpress/one-app-module-wrapper': '^3.4.2',
      '@americanexpress/travel-selectors': '^5.0.0',
      '@americanexpress/one-experiments': '^2.1.3',
      'react-intl': '^6.3.2',
      'fetchye-one-app': '^1.6.0'
    }
  });
}